import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import { useNotificationWebSocket } from "@/react/hooks/notifications/useNotificationWebSocket";

import {
  WEBSOCKET_EVENT_ERROR,
  WEBSOCKET_EVENT_SUCCESS,
  type VoiceMessageWebsocketEvent,
} from "../constants";

interface UseWebsocketProps {
  onClose: () => void;
  recordingId: string;
  setServerError: () => void;
}

export const useWebsocket = ({
  onClose,
  recordingId,
  setServerError,
}: UseWebsocketProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const { id: currentCommunityMemberId = 0 } = currentCommunityMember || {};
  const { localAttachments, setLocalAttachments } = useTipTapEditorContext();

  useNotificationWebSocket(
    currentCommunityMemberId,
    (eventData: VoiceMessageWebsocketEvent) => {
      if (
        (eventData.event === WEBSOCKET_EVENT_SUCCESS ||
          eventData.event === WEBSOCKET_EVENT_ERROR) &&
        eventData.json_message.recording_id === recordingId
      ) {
        if (eventData.event === WEBSOCKET_EVENT_SUCCESS) {
          setLocalAttachments([
            ...localAttachments,
            {
              url: eventData.json_message.url,
              signed_id: eventData.json_message.signed_id,
              content_type: eventData.json_message.content_type,
              metadata: { voice_message: true },
            },
          ]);

          onClose();
        } else if (eventData.event === WEBSOCKET_EVENT_ERROR) {
          setServerError();
        }
      }
    },
  );
};
